<template>
  <card id="mapContainer" no-header no-body no-footer>
    <div slot="card-table">
      <l-map id="map" :markers="gateways" class="border-0">
        <l-cluster :markers="gateways"
                   :marker-color="m => m.color"
                   :popup-data="['eui', 'description', 'connection']"
                   popup
                   icon="gateway"
                   popup-content="<a href='#/gateways/$0'>$0</a><br><em>$1</em><br>$2"
        />
      </l-map>
    </div>
  </card>
</template>

<script>
import { isEmpty, map, upperFirst } from 'lodash-es'
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'

export default {
  data () {
    return {
      gateways: []
    }
  },

  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(['selectedFleet'])
  },

  watch: {
    // When selectedFleet change, get gateway count for this fleet
    selectedFleet: 'getFleetsGateways'
  },

  methods: {
    async getFleetsGateways () {
      if (isEmpty(this.selectedFleet)) return

      const fields = ['eui', 'latitude', 'longitude', 'gpsLatitude', 'gpsLongitude', 'description', 'connection']
      let error, response
      [error, response] = await to(this.$api.getAllGateways(this.selectedFleet, { fields: fields.join(',') }))
      if (error || !response) return

      // Format description and status
      this.gateways = map(response.data.list, gateway => {
        // Get correct description to be displayed according to gateway version
        if (gateway.description) {
          const descSplitted = gateway.description.split(' ')
          // wirnet.<type>
          if (gateway.description.indexOf('wirnet.') !== -1) gateway.description = descSplitted[0]
          // Wirnet <type>
          else gateway.description = descSplitted[0] + ' ' + descSplitted[1]
        } else {
          gateway.description = ''
        }

        // Category to color PruneCluster (0: unknown, 1: connected, 2: disconnected)
        gateway.category = gateway.connection === true
          ? 1
          : gateway.connection === false
            ? 2
            : 0
        gateway.color = gateway.connection === true
          ? 'green'
          : gateway.connection === false
            ? 'red'
            : 'lightgray'
        gateway.connection = gateway.connection
          ? '<span class="text-success">' + upperFirst(this.$t('f-map:connected')) + '</span>'
          : '<span class="text-danger">' + upperFirst(this.$t('f-map:disconnected')) + '</span>'

        // If no manual positions, use GPS positions
        if (!gateway.latitude) gateway.latitude = gateway.gpsLatitude
        if (!gateway.longitude) gateway.longitude = gateway.gpsLongitude
        return gateway
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  #mapContainer {
    min-height: 310px;
  }

  #map {
    height: 308px;
  }
</style>
